var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6365 0.100342L15.6463 0.101318L16.3387 0.231201L16.3484 0.233154L16.3572 0.236084C16.5551 0.313598 16.7361 0.426072 16.9012 0.569092L16.9061 0.565186L16.9744 0.629639L20.7381 4.19702C21.1018 4.54169 21.2996 4.99381 21.2996 5.48218V22.4851C21.2996 23.4871 20.4354 24.2996 19.3904 24.2996L2.00957 24.2986C0.965702 24.2986 0.100391 23.4872 0.100388 22.4841L0.101364 1.91382C0.101364 0.911751 0.965734 0.100373 2.00957 0.100342H15.6365ZM2.00957 1.44312C1.72541 1.44329 1.50761 1.65802 1.50761 1.91382V22.4851C1.50761 22.7417 1.72627 22.9556 2.00957 22.9558H19.3934C19.6766 22.9557 19.8953 22.7408 19.8953 22.4851V5.50171L19.7342 5.13647L15.9861 1.58276L15.9842 1.58081L15.8182 1.47241C15.767 1.4541 15.7038 1.44312 15.6287 1.44312H2.00957ZM15.8963 17.7V19.0427H5.50664V17.7H15.8963ZM15.8963 13.2849V14.6277H5.50664V13.2849H15.8963ZM13.5643 4.97144L14.4178 5.78003L14.4939 5.85229L14.4178 5.92456L10.0965 10.0193C9.82188 10.2783 9.37997 10.2787 9.10625 10.0193L6.98418 8.00854L6.908 7.93628L6.98418 7.86304L7.83672 7.05542L7.90605 6.98999L7.97441 7.05542L9.60136 8.59644L13.4266 4.97144L13.4959 4.90601L13.5643 4.97144Z",
    fill: "#28AB6E",
    stroke: "#28AB6E",
    strokeWidth: 0.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.57856dcf91e918a371deb26a3d7725dc.svg";
export { ForwardRef as ReactComponent };